import axios from 'axios';
import { ROOT_URL, API_GATEWAY_URL } from './urlTypes';

export const searchDictionaryTree = (
  uid,
  accountId,
  productNo,
  searchType,
  searchText,
) =>
  new Promise(resolve => {
    const url = `${ROOT_URL}/dictionary/search`;
    axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      data: {
        uid: `${uid}`,
        accountId: `${accountId}`,
        productNo: `${productNo}`,
        searchType: `${searchType}`,
        searchText: `${searchText}`,
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => resolve(response.data.data))
      .catch(response => console.warn(response.data));
  });

export const getDictionaryTreeLoad = (
  uid,
  accountId,
  productNo,
  nodeID,
  filter
) =>
  new Promise(resolve => {
    const url = `${ROOT_URL}/dictionary/treeloadex`;
    axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        uid,
        accountId,
        productNo,
        node: nodeID,
        filter,
      },
    })
      .then(response => resolve(response.data.data))
      .catch(response => console.warn(response.data));
  });

export const getTemplateData = (uid, accountId, productNo, nodeID) =>
  new Promise(resolve => {
    const url = `${ROOT_URL}/dictionary/acinfo/${accountId}/${uid}/${productNo}/${nodeID}`;
    axios({
      url,
      method: 'get',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => resolve(response.data.data))
      .catch(response => console.warn(response.data));
  });

  export const getDicForDefKeywords = (
    uid,
    accountId,
    productNo,
    keywordsList
  ) =>
    new Promise(resolve => {
      const url = `${ROOT_URL}/dictionary/detail/${uid}/${accountId}/${productNo}`;
      axios({
        url,
        method: 'post',
        headers: {
          accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        data: keywordsList,
      })
      .then(response => resolve(response.data.data))
      .catch(response => console.warn('Api failed to get dictionary details for keywords'));
    });

// export const getDicForDefKeywords = async (
//   uid,
//   accountId,
//   productNo,
//   keywordsList
// ) => {
//   const url = `${ROOT_URL}/dictionary/detail/${uid}/${accountId}/${productNo}`;
//   try {
//     const response = await axios({
//       url,
//       method: 'post',
//       headers: {
//         accept: 'application/json;charset=UTF-8',
//       },
//       withCredentials: true,
//       responseType: 'json',
//       data: keywordsList,
//     });
//     const responseType = typeof response.data;
//     if (response.data && responseType === 'object') {
//       return response.data.data;
//     }
//     return false;
//   } catch (error) {
//     console.warn('Api failed to get dictionary details for keywords');
//     return false;
//   }
// };

export const patchEditDefinitions = async (
  accountId,
  ssid,
  definitionId,
  expressionList
) => {
  const url = `${API_GATEWAY_URL}/api/dictionary-service/definitions/expressions/${accountId}/${ssid}/${definitionId}`;
  try {
    const response = await axios({
      url,
      method: 'put',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: expressionList,
    });
    if (response.status === 200) return response.status;
    return false;
  } catch (error) {
    console.warn('Api failed to edit Definition details');
    return false;
  }
};

export const deleteDefinitionExpressions = async (
  accountId,
  ssid,
  definitionId,
  expressionIdList
) => {
  const url = `${API_GATEWAY_URL}/api/dictionary-service/definitions/expressions/delete/${accountId}/${ssid}/${definitionId}`;
  try {
    const response = await axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: expressionIdList,
    });
    if (response.status === 200) return response.status;
    return false;
  } catch (error) {
    console.warn('Api failed to delete Definition Expressions');
    return false;
  }
};

export const fetchNodeObjectForDefinition = async (accountId, expressionIdList) => {
  const ids = expressionIdList.join(",");
  const url = `${API_GATEWAY_URL}/api/dictionary-service/definitions/expressions/acnode/${accountId}?ids=${ids}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    });
    if (response.status === 200) return response.data.data;
    return false;
  } catch (error) {
    return false;
  }
}

export const getSampleWeighted = async (
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
) => {
  const url = `${ROOT_URL}/crosstab/samplewgtd`;
    try {
      const response = await axios({
        url,
        method: 'post',
        headers: {
          accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        data: {
          uid,
          accountId,
          productNo,
          weightType,
          divisor,
          expressionList,
        },
      });
      if (response.status === 200) return response.data.data;
      return false;
    } catch (error) {
      console.warn('Api failed to get Sample weigthed');
      return false;
    }
};
